import React from 'react';
import { useModal } from '../../hooks/useModal';
import SimpleModal from './SimpleModal';

const ModalContainer: React.FC = () => {
    const { modals, removeModal } = useModal();

    const handleClose = (id: string) => {
        // Просто удаляем модалку сразу, без анимации
        removeModal(id);
    };

    return (
        <>
            {modals.length > 0 && (
                <SimpleModal
                    key={modals[modals.length - 1].id}
                    modal={modals[modals.length - 1]}
                    onClose={() => handleClose(modals[modals.length - 1].id)}
                />
            )}
        </>
    );
};

export default ModalContainer;
